import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
} from '@material-ui/core';
import { DragIndicator, MoreHoriz } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import {
  ROOM_CREATE,
  ROOM_EDIT,
  ROOM_VIEW,
  ROOM_FILTER_MENU,
} from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import { useSelector, useDispatch } from 'react-redux';
import {
  allCategoriesSelector,
  allRoomsSelector,
  allRoomTypesSelector,
  fetchAllAccommodations,
  setAllRooms,
} from '../../../../property/propertySlice';
import { bouquetSelector } from '../../../../cms/cmsSlice';
import { campainNotificatons, emailServicesSelector } from '../../../../services/servicesSlice';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import WarningPopup from '../../../../../shared/warning-popup/Warning-Popup';
import { deleteAccommodationRoomAPI, getWelcomeMessages } from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import { isDragDisabled } from '../../../../../utils/formUtils';
import { decryptLocalStorage } from '../../../../../utils/authUtils';

const RoomTypeList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    number: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });

  const originalRoomTypes = useSelector(allRoomTypesSelector);
  const originalRooms = useSelector(allRoomsSelector);
  const bouquetList = useSelector(bouquetSelector);
  const allNotificationsOriginal = useSelector(campainNotificatons);
  const emailServicesList = useSelector(emailServicesSelector);
  const [initalRooms, setInitalroomTyps] = useState([]);
  const originalCategories = useSelector(allCategoriesSelector);
  const [rooms, setRooms] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterMenu, setFilterMenu] = useState([]);
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(selectedHotel);
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [dragEnabled, setDragEnabled] = useState(true);

  const setInitialRooms = () => {
    // assigning data set to local list while keeping an orginal data set for filtering
    const roomList = originalRooms.map((obj) => {
      const catObj = originalCategories.find((c) => c.id === obj.categoryId);
      const roomTypeObj = originalRoomTypes.find((r) => r.id === obj.roomTypeId);
      const returnObj = {
        ...obj,
        category: catObj ? catObj.name : '',
        roomType: roomTypeObj ? roomTypeObj.name : '',
      };
      return returnObj;
    });
    setInitalroomTyps(roomList);
  };

  useEffect(() => {
    setSearchText('');
    setInitialRooms();
  }, [originalRoomTypes, originalCategories, originalRooms]);

  const resetFilterDataList = () => {
    if (originalCategories && originalCategories?.length > 0) {
      ROOM_FILTER_MENU[1].subMenu = originalCategories?.map((obj) => ({
        id: obj?.id,
        name: obj?.name,
        selected: false,
      }));
    } else {
      ROOM_FILTER_MENU[1].subMenu = [];
    }

    if (originalRoomTypes && originalRoomTypes?.length > 0) {
      ROOM_FILTER_MENU[2].subMenu = originalRoomTypes?.map((obj) => ({
        id: obj?.id,
        name: obj?.name,
        selected: false,
      }));
    } else {
      ROOM_FILTER_MENU[2].subMenu = [];
    }
    setFilterMenu([...ROOM_FILTER_MENU]);
  };

  useEffect(() => {
    resetFilterDataList();
  }, [originalRoomTypes, originalCategories]);

  useEffect(() => {
    setFilteredBaseList(initalRooms);
    setRooms(initalRooms);
    setLoading(false);
  }, [initalRooms]);

  useEffect(() => {
    if (loading || rooms?.length === 0) return;
    const totalItems = rooms?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [rooms?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const handleFilter = (filterItems, field) => {
    if (field === 'all') {
      setFilteredBaseList(initalRooms);
      setRooms(initalRooms);
      resetFilterDataList();
    } else {
      const filterIdWithFields = filterMenu
        .filter((initialFilter) => initialFilter.subMenu.length > 0)
        .map((filterItem) => {
          const subMenuFiltersId = filterItem.subMenu
            .filter((fItem) => fItem.selected === true)
            .map((fItemId) => fItemId.id);
          if (subMenuFiltersId.length > 0) {
            return {
              id: subMenuFiltersId,
              field: filterItem.field,
            };
          } else return null;
        })
        .filter((item) => item !== null);
      const filteredRecords = initalRooms.filter((treatment) => {
        const doesFilterSatisfy = filterIdWithFields.map((filter) =>
          filter.id.includes(treatment[filter.field]),
        );
        return !doesFilterSatisfy.includes(false);
      });
      onsetPage(0);
      setFilteredBaseList(filteredRecords);
      setRooms(filteredRecords);
    }
  };

  const handleSearchText = (searchText) => {
    setSearchText(searchText);
    const filteredRows = filteredBaseList.filter((item) =>
      item.number?.toLowerCase().includes(searchText.toLowerCase()),
    );
    onsetPage(0);
    setRooms(filteredRows);
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onOpenDrawer = (event, type) => {
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.room);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      number: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      room: null,
    });
  };

  const handleCellMenuClick = (event, room) => {
    event.stopPropagation();
    setSelectedValue({
      id: room.id,
      number: room.number,
      name: 'Room ' + room.number,
      title: '',
      description: '',
      status: false,
      anchorEl: event.currentTarget,
      room: room,
      warn: false,
    });
  };

  const deleteAccommodationRoomDetails = async (e, number) => {
    e.preventDefault();

    const selectedBouquetRoomNo = bouquetList?.map((item) => item.room);
    const selectedNotificationRoomNo = allNotificationsOriginal?.map((item) => item.residentRoom);

    const notificationMapped = selectedNotificationRoomNo?.toString().includes(number);
    const bouquetMapped = selectedBouquetRoomNo?.toString().includes(number);
    const emailMapped = (emailServicesList || [])?.some((s) =>
      s?.audience?.guests?.rooms?.values?.includes(number),
    );

    let welcomeMapped = false;
    try {
      if (selectedHotel) {
        const lang = decryptLocalStorage('lang');
        const getByLang = lang !== 'en' ? lang : '';
        const res = await getWelcomeMessages(selectedHotel, getByLang);
        const messages = res?.data?.listWelcomeMessage || [];
        welcomeMapped = messages?.some((m) => m?.audienceCriteria?.rooms?.values?.includes(number));
      }
    } catch (err) {
    }

    const modules = [];
    if (emailMapped) modules.push('Email Templates');
    if (notificationMapped) modules.push('Notifications');
    if (welcomeMapped) modules.push('Welcome Messages');
    if (bouquetMapped) modules.push('TV Channels-Bouquets');

    const showAlertMessage = {
      title: modules.length > 0 ? 'Unable to delete' : 'Are you sure you want to delete',
      description:
        modules.length > 0
          ? `The selected room number cannot be deleted as it has been configured under one or more ${modules.join(
              ' and ',
            )}`
          : 'This action cannot be reversed',
      warn: modules.length > 0,
    };

    setSelectedValue((prev) => ({
      ...prev,
      title: showAlertMessage.title,
      description: showAlertMessage.description,
      status: true,
      warn: showAlertMessage.warn,
    }));
  };

  const deleteRoomDetails = async () => {
    try {
      const lang = decryptLocalStorage('lang');
      const delByLang = lang !== 'en' ? lang : '';
      if (selectedHotel && selectedValue && selectedValue.id) {
        await deleteAccommodationRoomAPI(selectedHotel, selectedValue.id, delByLang);
        dispatch(fetchAllAccommodations(selectedHotel));
        notificationManager('success', 'Room Details deleted successfully');
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Room Details');
      }
      handleClose();
    }
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      warn: false,
    });
  };

  const onViewDetails = (room, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(ROOM_VIEW, true, room);
    }
  };

  const onClickView = (e) => {
    if (selectedValue && selectedValue.room) {
      onViewToggle(ROOM_VIEW, true, selectedValue.room);
    }
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);
  const dragDisabled = !dragEnabled || rooms?.length <= 1;
  return (
    <div className='mt-4 mb-4 group-list-container'>
      {selectedValue.id && selectedValue.status === true && !selectedValue.warn && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteRoomDetails}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {selectedValue.id && selectedValue.status === true && selectedValue.warn && (
        <WarningPopup warningPopup={selectedValue} onWarningClose={handleClose} warn={true} />
      )}

      <SearchBar
        type={ROOM_CREATE}
        buttonName='Add Room'
        onOpenDrawer={onOpenDrawer}
        setSearchText={handleSearchText}
        filterList={filterMenu}
        displayAddOrEdit={
          permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
            ? 'show'
            : 'hide'
        }
        setFilterDataList={setFilterMenu}
        filteredRecoard={handleFilter}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={rooms}
        setPlaceHolder={setRooms}
        globalPlaceHolder={originalRooms}
        setGlobalPlaceHolder={setAllRooms}
        globalCategoryPlaceHolder={originalCategories}
        globalRoomTypePlaceHolder={originalRoomTypes}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='Accommodations room'
        module='ACCOMMODATION_ROOM'
        searchText={searchText}
        setSearch={setSearchText}
        actionMenuItems={[]}
        setDrag={setDragEnabled}
      />

      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          rooms && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell className='w-30'>Room Number</TableCell>
                    <TableCell className='w-30'>Room Type</TableCell>
                    <TableCell className='w-30'>Category</TableCell>
                    <TableCell className='w-10' align='right'></TableCell>
                  </TableRow>
                </TableHead>

                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(event, setVisible, rooms, setRooms, false, page, rowsPerPage)
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='spas' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? rooms.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : rooms
                        ).map((room, i) => (
                          <Draggable
                            key={room.id}
                            draggableId={room.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onViewDetails(room, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <TableCell>
                                  {!dragDisabled && (
                                    <DragIndicator className='res-menu-accordion-drag' />
                                  )}{' '}
                                </TableCell>
                                <TableCell className='w-30'>{room?.number}</TableCell>
                                <TableCell className='w-30'>{room?.roomType}</TableCell>
                                <TableCell className='w-30'>{room?.category}</TableCell>
                                <TableCell className='w-10' align='right'>
                                  {permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, room);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={i}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === room.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, ROOM_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onClickView(e);
                                      }}
                                    >
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        deleteAccommodationRoomDetails(e, room.number);
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={rooms.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
      </div>
    </div>
  );
};

export default RoomTypeList;
